import React from 'react';
import { KeyValueObject } from '../../types/shared';

import './style.css';

export default function SpinnerLogo({ className }: KeyValueObject<string>) {
      return (
            <img src={"/dropzik-logo.png"} alt="dropzik inc" />
      )
}
